// Numbers the way the HUD shows them.

/** 36723 → "36,723" */
export const fmtNum = (n: number | string | null | undefined): string => {
  const v = typeof n === "string" ? Number(n) : n;
  if (v === null || v === undefined || !Number.isFinite(v)) return "—";
  return Math.round(v).toLocaleString("en-US");
};

/** 500000 → "500K", 1234567 → "1.2M", 21400 → "21.4K", 950 → "950" */
export const abbrev = (n: number | null | undefined): string => {
  if (n === null || n === undefined || !Number.isFinite(n)) return "—";
  const a = Math.abs(n);
  const f = (v: number, unit: string) => {
    const s = v >= 100 ? v.toFixed(0) : v >= 10 ? v.toFixed(1) : v.toFixed(1);
    return s.replace(/\.0$/, "") + unit;
  };
  if (a >= 1e9) return f(n / 1e9, "B");
  if (a >= 1e6) return f(n / 1e6, "M");
  if (a >= 1e3) return f(n / 1e3, "K");
  return String(Math.round(n));
};

/** "505,518" → [505, 518] */
export const parseCoords = (s: string | null | undefined): [number, number] | null => {
  if (!s) return null;
  const m = /(-?\d+)\s*,\s*(-?\d+)/.exec(s);
  return m ? [Number(m[1]), Number(m[2])] : null;
};

/** [505, 518] → "(505, 518)" */
export const fmtCoords = (xy: [number, number] | string | null | undefined): string => {
  const c = typeof xy === "string" ? parseCoords(xy) : xy;
  return c ? `(${c[0]}, ${c[1]})` : "—";
};

/** Rank "#19" */
export const fmtRank = (n: number | null | undefined): string => (n && n > 0 ? `#${fmtNum(n)}` : "—");

export const plural = (n: number, one: string, many = one + "s") => `${fmtNum(n)} ${n === 1 ? one : many}`;
